import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["defaultOpen"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { useState } from "react";
import PropTypes from "prop-types";
import O2Tooltip from "./o2-tooltip";

var O2UncontrolledTooltip = function O2UncontrolledTooltip(props) {
  var _useState = useState(props.defaultOpen),
      open = _useState[0],
      setOpen = _useState[1];

  var defaultOpen = props.defaultOpen,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var toggleHandler = function toggleHandler() {
    setOpen(!open);
  };

  return /*#__PURE__*/React.createElement(O2Tooltip, _extends({
    isOpen: open,
    toggle: toggleHandler
  }, attributes));
};

O2UncontrolledTooltip.propTypes = _objectSpread({
  defaultOpen: PropTypes.bool
}, O2Tooltip.propTypes);
O2UncontrolledTooltip.defaultProps = {
  defaultOpen: false
};
export default O2UncontrolledTooltip;